import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-main-footer-container',
  templateUrl: './main-footer-container.component.html',
  styleUrls: ['./main-footer-container.component.scss'],
})
export class MainFooterContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
